import * as Yup from "yup";
import { validation, conditionalValidation } from "../../../utils/constants"

export const FormikObj = {
    initialValues: {
        encounterId: "",
        practitionerName: "",
        patientName: "",
        requestType: "",
        recipient: "",
        documentId: "",
    },
    validationSchema: Yup.object({
        encounterId: conditionalValidation(
            Yup.string().matches(/^\s*\S[\s\S]*$/, 'Only blankspace is not valid.'),
            {
                validation,
                mandatory: true
            }),
        practitionerName: conditionalValidation(
            Yup.string().matches(/^\s*\S[\s\S]*$/, 'Only blankspace is not valid.'),
            {
                validation,
                mandatory: true
            }),
        patientName: conditionalValidation(
            Yup.string().matches(/^\s*\S[\s\S]*$/, 'Only blankspace is not valid.'),
            {
                validation,
                mandatory: true
            }),

        requestType: conditionalValidation(
            Yup.string().matches(/^\s*\S[\s\S]*$/, 'Only blankspace is not valid.'),
            {
                validation,
                mandatory: true
            }),
        documentId: conditionalValidation(
            Yup.string().matches(/^\s*\S[\s\S]*$/, 'Only blankspace is not valid.'),
            {
                validation,
                mandatory: true
            })
    }),
}

export const locaitonModalFormikObj = {
    initialValues: {
        recepient: "",
        locationId: "",
        name: "",
        HCN: "",
        locationFax_number: "",
    },
    validationSchema: Yup.object({
        recepient: conditionalValidation(
            Yup.string().matches(/^\s*\S[\s\S]*$/, 'Only blankspace is not valid.'),
            {
                validation,
                mandatory: true
            }),
        locationId: conditionalValidation(
            Yup.string().when("recepient", (recepient, schema) => {
            return recepient === "location"
                ? schema.required('Required field.').matches(/^\s*\S[\s\S]*$/, 'Only blankspace is not valid.')
                : schema}),
            {
                validation
            })
    }),
}


export const formFieldsToEdit = [
    [{
        fieldType: "TextInput",
        keyField: "encounterId",
        label: "Encounter ID",
        placeholder: "111D1",
        disabled: true
    },
    {
        fieldType: "TextInput",
        keyField: "practitionerName",
        label: "Practitioner Name",
        disabled: true
    },
    {
        fieldType: "TextInput",
        keyField: "patientName",
        label: "Patient Name",
        disabled: true,
    }],
    [{
        fieldType: "TextInput",
        keyField: "requestType",
        label: "Request Type",
        disabled: true,
    },
    {
        fieldType: "SelectFiled",
        keyField: "recipient",
        label: "Select Recipient",
        disabled: true,
        required: false,
    },
    {
        fieldType: "SelectFiled",
        keyField: "questionnaire",
        label: "Select Questionnaire",
        
    }],
]